import { AsyncQueries, AsyncQueriesParams } from "../base";
import { AltiusRes } from "../../../store/types";
import { AxiosResponse } from "axios";
import { GetInvestmentHoldingsResponse, PlaidConnection, PlaidDeal, Security } from "../../../store/types/plaid/api";

export interface IPlaidQueries {
  getInvestmentHoldings: (accessToken: string) => Promise<GetInvestmentHoldingsResponse>;
  syncInvestmentHoldings: (itemId: string, from: Date) => Promise<PlaidConnection>;
  getConnections: () => Promise<PlaidConnection[]>;
  deleteConnection: (connectionId: number) => Promise<void>;
  getConnectionDeals: (connectionId: number) => Promise<PlaidDeal[]>;
  getSecurities: () => Promise<Security[]>;
}

export class PlaidQueries extends AsyncQueries implements IPlaidQueries {
  public constructor(params: AsyncQueriesParams) {
    super(params);
  }

  public getConnections = async () => {
    const res = await this.api.get<AltiusRes<PlaidConnection[]>>({
      url: "/api/v0.0.3/plaid/connections"
    });

    return res.data.data;
  };

  public getConnectionDeals = async (connectionId: number) => {
    const res = await this.api.get<AltiusRes<PlaidDeal[]>>({
      url: `/api/v0.0.3/plaid/connections/${connectionId}/deals`
    });

    return res.data.data;
  };

  public getInvestmentHoldings = async (accessToken: string) => {
    const res: AxiosResponse<AltiusRes<GetInvestmentHoldingsResponse>> = await this.api.get({
      url: "/api/v0.0.3/plaid/get-investment-holdings",
      params: { access_token: accessToken }
    });

    return res.data.data;
  };

  public syncInvestmentHoldings = async (itemId: string, from: Date) => {
    const res = await this.api.post<AltiusRes<PlaidConnection>>({
      url: "/api/v0.0.3/plaid/sync-investment-holdings",
      data: {
        item_id: itemId,
        from
      }
    });

    return res.data.data;
  };

  public deleteConnection = async (connectionId: number) => {
    await this.api.delete({
      url: "/api/v0.0.3/plaid/connections/" + connectionId
    });
  };

  public getSecurities = async () => {
    const res = await this.api.get<AltiusRes<Security[]>>({
      url: "/api/v0.0.3/plaid/deals"
    });

    return res.data.data;
  };
}
